import { render, staticRenderFns } from "./SelectBranch.vue?vue&type=template&id=3d661f1b&scoped=true&"
import script from "./SelectBranch.vue?vue&type=script&lang=ts&"
export * from "./SelectBranch.vue?vue&type=script&lang=ts&"
import style0 from "./SelectBranch.vue?vue&type=style&index=0&id=3d661f1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d661f1b",
  null
  
)

export default component.exports